/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Čtvrtek`
};

const da_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Torsdag`
};

const de_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Donnerstag`
};

const en_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Thursday`
};

const es_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Jueves`
};

const fr_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Jeudi`
};

const hu_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Csütörtök`
};

const it_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Giovedì`
};

const nl_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Donderdag`
};

const pl_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Czwartek`
};

const pt_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Quinta-feira`
};

const sv_weekdays_thursday = /** @type {(inputs: {}) => string} */ () => {
	return `Torsdag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const weekdays_thursday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.weekdays_thursday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("weekdays_thursday", locale)
	if (locale === "cs") return cs_weekdays_thursday(inputs)
	if (locale === "da") return da_weekdays_thursday(inputs)
	if (locale === "de") return de_weekdays_thursday(inputs)
	if (locale === "en") return en_weekdays_thursday(inputs)
	if (locale === "es") return es_weekdays_thursday(inputs)
	if (locale === "fr") return fr_weekdays_thursday(inputs)
	if (locale === "hu") return hu_weekdays_thursday(inputs)
	if (locale === "it") return it_weekdays_thursday(inputs)
	if (locale === "nl") return nl_weekdays_thursday(inputs)
	if (locale === "pl") return pl_weekdays_thursday(inputs)
	if (locale === "pt") return pt_weekdays_thursday(inputs)
	return sv_weekdays_thursday(inputs)
};
export { weekdays_thursday as "weekdays.thursday" }